export const detectPlatform = () => {
  let ua = navigator.userAgent.toLowerCase();

  if (/android/.test(ua)) return 'android';
  if (/iphone|ipad/.test(ua)) return 'ios';
  if (/mac os x/.test(ua) || /windows nt/.test(ua)) return 'desktop';
  return 'unknown';
};
